// :cow: Cosmose CONFIDENTIAL :iso:
export enum ImageSuggestionListVariant {
  LS = 'LS',
  ARTICLE = 'ARTICLE'
}
